import Repository from '../Repository';

const resource = '/group';

export default {
	list(params) {
		return Repository.get(`${resource}/list`, { params: params });
	}
}